export default "__VITE_ASSET__0e18ac04__"